import { isSameDay, subDays } from 'date-fns';
import { formatters } from 'folio-common-utils';
export function formatDateGroupHeader(dateTime) {
    const now = new Date();
    if (isSameDay(dateTime, now)) {
        return 'I dag';
    }
    else if (isSameDay(dateTime, subDays(now, 1))) {
        return 'I går';
    }
    const format = dateTime.getFullYear() === now.getFullYear()
        ? 'eeee do MMMM'
        : 'eeee do MMMM yyyy';
    return formatters.capitalize(formatters.formatDate(dateTime, format));
}
function requirementToLabel(requirement) {
    switch (requirement) {
        case 'Category':
            return 'kategori';
        case 'Participants':
            return 'deltakerliste';
        case 'Purpose':
            return 'formål';
        case 'Receipt':
            return 'kvittering';
    }
}
export function formatRequirementsProgress(event) {
    const { totalRequirementCount, metRequirementCount, unmetRequirements, allRequirementsMet, } = event.requirements;
    const header = allRequirementsMet
        ? 'Denne er ferdig!'
        : `${metRequirementCount} av ${totalRequirementCount} fullført`;
    const body = allRequirementsMet
        ? 'Denne er klar for regnskapet!'
        : `Legg til ${formatters.joinRunningTextList(unmetRequirements.map(requirementToLabel))}, så er denne klar for regnskapet.`;
    return { header, body };
}
//# sourceMappingURL=formatters.js.map